import client from '../client'
import { base64ToBlob } from 'utils/utils'

/**
 * payload: {
 *  path: string, // 'task_img' or 'task_original_img',
 *  files: Blob | string, // base64 data url
 * }
 */
export const uploadOnboardingImage = async ({ path, files }) => {
  let blobFile;

  if (files instanceof Blob) {
    blobFile = files
  } else {
    blobFile = await base64ToBlob(files)
  }

  const formData = new FormData()
  formData.append('path', path)
  formData.append('files', blobFile)

  const { data } = await client.post(
    '/file/onboarding',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
    },
  )

  return data
}